import React from 'react';
import styled, { keyframes } from 'styled-components';

import { Translate, useSingleInterpolatedTranslationKey } from '@dreryk/react-common';

import { translationKeys } from '../translations';

const pulse = keyframes`
   0%, 100% { opacity: 1; }
   50% { opacity: 0.6; }
`;

const StyledRoot = styled.div`
   display: flex;
   align-items: center;
   gap: 6px;
   padding: 6px 10px;
   border-radius: 6px;
   background-color: ${(props) => props.theme.warningLighter ?? '#fff8e1'};
   border: 1px solid ${(props) => props.theme.warning ?? '#f59e0b'};
   font-size: 12px;
   color: ${(props) => props.theme.warningDark ?? '#92400e'};
   animation: ${pulse} 1.2s ease-in-out infinite;
`;

const StyledIcon = styled.span`
   font-size: 14px;
   line-height: 1;
   flex-shrink: 0;
`;

type SilenceCountdownProps = {
   /** Seconds remaining until disconnect. null = hidden. */
   secondsRemaining: number | null;
};

/**
 *
 * Shows a pulsing warning below the VoiceVisualizer when silence is detected
 * and auto-disconnect is imminent. Disappears when the user starts speaking again.
 */
export const SilenceCountdown = (props: SilenceCountdownProps): JSX.Element | null => {
   const message = useSingleInterpolatedTranslationKey(
      translationKeys.silenceCountdown.message,
      'seconds',
      props.secondsRemaining
   );
   if (props.secondsRemaining === null) {
      return null;
   }
   return (
      <StyledRoot role={'status'} aria-live={'polite'}>
         <StyledIcon>{'🎙️'}</StyledIcon>
         <Translate>{message}</Translate>
      </StyledRoot>
   );
};
